<template>
  <div class="notification-page-container">
    <div class="notification-page-context">
      <div class="notification-head">
        <span>{{ notice.title }}</span>
      </div>
      <div class="notification-body" v-html="notice.content">
      </div>
      <div class="notification-foot">
        <p>{{ notice.date }}</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "NotificationPage",
  data() {
    return {
      notice: {
        title: '标题初始化中...',
        content: '内容初始化中...',
        date: '发布日期初始化中...'
      },
      where: new Map()
    };
  },
  created() {
    this.where.set('notice', '/api/notice');
    this.where.set('version', '/api/version');

    this.$http(this.where.get(this.$route.query.type) + '/id/' ,{id:this.$route.query.sign}).then((res)=>{
      if(res.data.status === 200) {
        this.notice = {
          title   : (res.data.data.hasOwnProperty('noticeTitle')   ? res.data.data.noticeTitle   : res.data.data.versionTitle),
          content : (res.data.data.hasOwnProperty('noticeContent') ? res.data.data.noticeContent : res.data.data.versionContent),
          date    : (res.data.data.hasOwnProperty('noticeDate')    ? res.data.data.noticeDate    : res.data.data.versionDate),
        }
      }
      else {
        this.$Message.error('数据初始化失败')
        // this.$Message.error(res.data.msg);
      }
    }).catch((error)=>{
      this.$Message.error('数据初始化异常')
      // this.$router.push({name:'survey'});
      // window.console.error(error);
    })
  },
  mounted() {
  },
  methods: {
  },
  destroyed() {
  },
};
</script>

<style scoped>
.notification-page-container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  background-color: #e7e8eb;
  overflow: auto;
}
.notification-page-context {
  width: 90%;
  max-width: 1600px;
  min-width: 400px;
  margin: 30px 0;
  padding: 40px;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  border-radius: 3px;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  -webkit-box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.05);
  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.05);
  color: #000000;
}
.notification-head {
  width: 100%;
  height: 40px;
  margin-bottom: 20px;
}
.notification-head span {
  display: inline-block;
  line-height: 40px;
  font-size: 20px;
  font-weight: bold;
  height: 100%;
  width: 100%;
  text-align: center;
  white-space: nowrap;
  text-overflow: ellipsis;
  word-break: break-all;
  overflow: hidden;
}
.notification-body {
  width: 100%;
  height: auto;
  min-height: 200px;
}
.notification-body p {
  word-break: break-all;
  word-wrap: break-word;
  font-size: 16px;
  line-height: 30px;
}
.notification-foot {
  margin: 10px 0;
}
.notification-foot p {
  font-size: 16px;
  text-align: right;
}
</style>
